import TextButton from 'components/Luxkit/Button/TextButton'
import BestPricesIcon from 'components/Luxkit/Icons/custom/BestPricesIcon'
import BinocularsIcon from 'components/Luxkit/Icons/custom/BinocularsIcon'
import BookingIcon from 'components/Luxkit/Icons/custom/BookingIcon'
import BuyNowBookLaterIcon from 'components/Luxkit/Icons/custom/BuyNowBookLaterIcon'
import ExclusiveAccessIcon from 'components/Luxkit/Icons/custom/ExclusiveAccessIcon'
import FlexibleBookingsIcon from 'components/Luxkit/Icons/custom/FlexibleBookingsIcon'
import HandpickedPartnersIcon from 'components/Luxkit/Icons/custom/HandpickedPartnersIcon'
import HotelIcon from 'components/Luxkit/Icons/custom/HotelIcon'
import RefundIcon from 'components/Luxkit/Icons/custom/RefundIcon'
import SevenDaysIcon from 'components/Luxkit/Icons/custom/SevenDaysIcon'
import VipInclusionsIcon from 'components/Luxkit/Icons/custom/VipInclusionsIcon'
import LineCalendarIcon from 'components/Luxkit/Icons/line/LineCalendarIcon'
import LineCheckCircleIcon from 'components/Luxkit/Icons/line/LineCheckCircleIcon'
import LineMapIcon from 'components/Luxkit/Icons/line/LineMapIcon'
import LineTicketIcon from 'components/Luxkit/Icons/line/LineTicketIcon'
import SvgIcon from 'components/Luxkit/SvgIcon'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

const Container = styled(Group)`
  max-width: ${rem(208)};
`

const howItWorksIcons: Record<string, typeof SvgIcon> = {
  '7-days': SevenDaysIcon,
  'quality-guaranteed': LineCheckCircleIcon,
  'best-prices': BestPricesIcon,
  'vip-inclusions': VipInclusionsIcon,
  hotel: HotelIcon,
  'flexible-bookings': FlexibleBookingsIcon,
  'handpicked-partner': HandpickedPartnersIcon,
  refund: RefundIcon,
  map: LineMapIcon,
  binoculars: BinocularsIcon,
  tickets: LineTicketIcon,
  'exclusive-access': ExclusiveAccessIcon,
  booking: BookingIcon,
  'buy-now-book-later': BuyNowBookLaterIcon,
  calendarIcon: LineCalendarIcon,
}

interface Props {
  item: any
  className?: string
  hideContent?: boolean
}

function HowItWorksItem(props: Props) {
  const { item, className, hideContent } = props
  const {
    icon,
    iconSize,
    title,
    content,
    contentSize = 'medium',
    iconType = 'primary',
    light,
    slug,
  } = item

  const Icon = howItWorksIcons[icon]

  return <Container direction="vertical" horizontalAlign="center" gap={16} className={className}>
    {!!Icon && <Icon size={iconSize} colour={iconType} />}
    <Group direction="vertical" horizontalAlign="center" gap={8}>
      <Heading variant="heading6" colour={light ? 'neutral-eight' : undefined} align="center">
        {title}
      </Heading>
      {!hideContent && content && <BodyText
        variant={contentSize}
        colour={light ? 'neutral-eight' : undefined}
        align="center"
      >
        {content}
      </BodyText>}
    </Group>
    {!!slug && <TextButton kind="tertiary" to={`/${slug}`}>Find out more</TextButton>}
  </Container>
}

export default HowItWorksItem
